import * as React from "react"

function SvgStarEmpty(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 22"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        d="M19.63 8.274a1.256 1.256 0 00-1.172-.817h-5.073a.415.415 0 01-.393-.278L11.17 2.02a1.25 1.25 0 00-2.341-.001l-.005.014L7.007 7.18a.415.415 0 01-.392.278H1.542a1.252 1.252 0 00-.803 2.21l4.32 3.583c.132.11.184.29.13.452l-1.816 5.443a1.25 1.25 0 001.925 1.403l4.455-3.266a.416.416 0 01.493 0l4.453 3.265a1.25 1.25 0 001.927-1.402L14.811 13.7a.415.415 0 01.129-.452l4.328-3.589c.399-.34.543-.892.361-1.384z"
      />
    </svg>
  )
}

export default SvgStarEmpty
